import React, { useEffect } from 'react';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';
import {
  useSuiteAPI,
  UseSuiteAPIReturn,
} from 'src/SharedCustomHooks/UseSuiteAPI/useSuiteAPI';
import {
  IUseCalendarDataReturn,
  useCalendarData,
} from 'src/pages/Calendar/CustomHooks/useCalendarData';
import KeyPickupContent from './components/KeyPickupContent/KeyPickupContent';
import { PATHS } from 'src/common/constants';

interface KeyPickupViewProps {
  match: { params: { id: string } };
  history: any;
}

const KeyPickupView = ({ match, history }: KeyPickupViewProps) => {
  const routeId: string = match.params.id;
  const suiteId: string = routeId.split('&')[1] || '';

  const { suite, fetchSuiteById }: UseSuiteAPIReturn = useSuiteAPI();

  const { keyPickupEvent, fetchKeyPickupEventBySuite }: IUseCalendarDataReturn =
    useCalendarData();

  useEffect(() => {
    if (!suiteId) {
      return;
    }

    fetchSuiteById(suiteId);
    fetchKeyPickupEventBySuite(suiteId);
  }, [suiteId]);

  const goBackToSuite = () =>
    history.push(PATHS.SUITES_VIEW.replace(':id', routeId));

  return (
    <WithNavigation
      title={suite ? `Key Pickup · ${suite.number}` : 'Key Pickup'}
    >
      <KeyPickupContent
        suite={suite}
        keyPickupEvent={keyPickupEvent}
        onBackToSuite={goBackToSuite}
      />
    </WithNavigation>
  );
};

export default KeyPickupView;
